import React, { useEffect, useRef, useState } from 'react';
import { Col, Form, Modal, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useClickAway } from 'react-use';
import { useGetRequest } from '../../../hooks/useGetRequest';

const SettingsModal = ({ isShow, setIsShow, hideItems, setHideItems }) => {
  const [prescriptionItems, setPrescriptionItems] = useState([]);
  const activeOrganization = useSelector(
    (state) => state.orgReducer.organization,
  );

  const { isLoading: isLoadingItems, refetch: getPrescriptionItems } =
    useGetRequest(
      'prescriptionItems',
      'settings/prescription-item-setting?organizationId=' +
        activeOrganization.id,
      (data) => {
        setPrescriptionItems(data.items);
      },
      (e) => {
        console.log(e);
      },
    );

  useEffect(() => {
    getPrescriptionItems();
  }, []);

  const rxItemName = (itemName) => {
    if (prescriptionItems) {
      const itemNames = {
        'chief-complain': 'Chief Complain',
        'chief-complaint': 'Chief Complain',
        history: 'History',
        diagnosis: 'Diagnosis',
        'on-examination': 'On Examinations',
        investigation: 'Investigations',
        rx: 'Rx',
        rehabilitation: 'Rehabilitation',
        'follow-up': 'Follow-Up',
        advice: 'Advice',
        infertility: 'Infertility',
        'eye-glass': 'Eye-Glass',
        'special-note': 'Special Note',
        signature: 'Signature',
        predictions: 'Predictions',
        referredto: 'Referred To',
        'treatment-plan': 'Treatment To',
      };
      return itemNames[itemName];
    } else {
      return '';
    }
  };

  const handleHideItems = (item, val) => {
    setHideItems({ ...hideItems, [item]: val });
  };

  const ref = useRef(null);
  useClickAway(ref, (e) => {
    setIsShow(false);
  });

  return (
    <Modal size="lg" show={isShow}>
      <Modal.Header className="common-modal-header">
        <Col>
          <Modal.Title>Item Hide In Print</Modal.Title>
        </Col>
        <Col md={4}></Col>
        <Col md={1} style={{ textAlign: 'end' }}>
          <i
            className="fa fa-times cursor-pointer text-danger"
            aria-hidden="true"
            onClick={() => setIsShow(false)}
          ></i>
        </Col>
      </Modal.Header>
      <Modal.Body ref={ref}>
        <Row className="mb-2">
          <Col>
            <div
              style={{
                fontSize: '20px',
                borderBottom: '2px solid #e3e6f0',
                display: 'inline',
                paddingBottom: '8px',
              }}
            >
              <b>Select the items you want to hide in print:</b>
            </div>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col>
            {prescriptionItems &&
              Object.keys(prescriptionItems)
                .filter((key) => prescriptionItems[key]?.enabled === true)
                .map(
                  (item, index) =>
                    rxItemName(item) && (
                      <Row key={index} className="pt-1">
                        <Col md={12} className="pl-4">
                          <span
                            style={{ paddingRight: '10px', fontWeight: 'bold' }}
                          >
                            {rxItemName(item)}{' '}
                          </span>
                          <Form.Check
                            type="checkbox"
                            label="Hide"
                            style={{
                              display: 'inline-block',
                            }}
                            checked={hideItems?.[item] || false}
                            onChange={(e) =>
                              handleHideItems(item, e.target.checked)
                            }
                          />
                        </Col>
                      </Row>
                    ),
                )}
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
};

export default SettingsModal;
